/* Talho Argentino — textos e íconos del selector de entrega (ver talho-entrega.js).
   19/10/2026: "sinElegir" acortado para que la barra entre en una fila en mobile (mantener igual que te_pregunta en snippets/talho-entrega.liquid). Backup: talho-entrega-textos-backup-19oct.js */
(function(){
window.TalhoEntregaTextos = function (lang) {
    var es = {
      envio: 'Envío a domicilio', retirarEn: 'Retirar en', cambiar: 'Cambiar',
      comoRecibir: '¿Cómo querés recibir tu pedido?', cambiarEntrega: 'Cambiar forma de entrega',
      explica: 'Te mostramos el stock correcto para la opción que elijas. Podés cambiarla cuando quieras arriba de la página.',
      noEnModo: 'Este producto no está disponible para {x}. Elegí otra opción.',
      disponible: 'Disponible', sinStock: 'Sin stock', listoEn: 'listo en',
      agregar: 'Agregar al carrito', guardar: 'Guardar', cerrar: 'Cerrar',
      noDisponibleEn: 'Este producto no está disponible para {x}.',
      sinAgregar: 'No se agregó al carrito.', sinStockEn: 'Sin stock para {x}.',
      disponibleCon: 'Disponible: {x} · cambiar', elegida: 'Elegida', elegir: 'Elegir',
      unoNoDisp: '1 producto no está disponible para {x}.', variosNoDisp: '{n} productos no están disponibles para {x}.',
      quitar: 'Quitar', pasarA: 'Cambiar a {x}',
      sinElegir: '¿Envío o retiro en tienda?', elegirBtn: 'Elegir'
    };
    var pt = {
      envio: 'Entrega ao domicílio', retirarEn: 'Levantar em', cambiar: 'Alterar',
      comoRecibir: 'Como quer receber a sua encomenda?', cambiarEntrega: 'Alterar forma de entrega',
      explica: 'Mostramos o stock certo para a opção escolhida. Pode alterar quando quiser no topo da página.',
      noEnModo: 'Este produto não está disponível para {x}. Escolha outra opção.',
      disponible: 'Disponível', sinStock: 'Sem stock', listoEn: 'pronto em',
      agregar: 'Adicionar ao carrinho', guardar: 'Guardar', cerrar: 'Fechar',
      noDisponibleEn: 'Este produto não está disponível para {x}.',
      sinAgregar: 'Não foi adicionado ao carrinho.', sinStockEn: 'Sem stock para {x}.',
      disponibleCon: 'Disponível: {x} · alterar', elegida: 'Escolhida', elegir: 'Escolher',
      unoNoDisp: '1 produto não está disponível para {x}.', variosNoDisp: '{n} produtos não estão disponíveis para {x}.',
      quitar: 'Remover', pasarA: 'Mudar para {x}',
      sinElegir: 'Entrega ou levantamento?', elegirBtn: 'Escolher'
    };
    var en = {
      envio: 'Home delivery', retirarEn: 'Pick up at', cambiar: 'Change',
      comoRecibir: 'How would you like to get your order?', cambiarEntrega: 'Change delivery method',
      explica: 'We show the right stock for the option you choose. You can change it anytime at the top of the page.',
      noEnModo: 'This product is not available for {x}. Choose another option.',
      disponible: 'Available', sinStock: 'Out of stock', listoEn: 'ready in',
      agregar: 'Add to cart', guardar: 'Save', cerrar: 'Close',
      noDisponibleEn: 'This product is not available for {x}.',
      sinAgregar: 'Not added to cart.', sinStockEn: 'Out of stock for {x}.',
      disponibleCon: 'Available: {x} · change', elegida: 'Selected', elegir: 'Choose',
      unoNoDisp: '1 product is not available for {x}.', variosNoDisp: '{n} products are not available for {x}.',
      quitar: 'Remove', pasarA: 'Switch to {x}',
      sinElegir: 'Delivery or pickup?', elegirBtn: 'Choose'
    };
    var fr = {
      envio: 'Livraison à domicile', retirarEn: 'Retrait à', cambiar: 'Modifier',
      comoRecibir: 'Comment souhaitez-vous recevoir votre commande ?', cambiarEntrega: 'Modifier le mode de livraison',
      explica: 'Nous affichons le stock correspondant à votre choix. Vous pouvez le modifier à tout moment en haut de la page.',
      noEnModo: 'Ce produit n’est pas disponible pour {x}. Choisissez une autre option.',
      disponible: 'Disponible', sinStock: 'Rupture', listoEn: 'prêt en',
      agregar: 'Ajouter au panier', guardar: 'Enregistrer', cerrar: 'Fermer',
      noDisponibleEn: 'Ce produit n’est pas disponible pour {x}.',
      sinAgregar: 'Non ajouté au panier.', sinStockEn: 'Rupture pour {x}.',
      disponibleCon: 'Disponible : {x} · modifier', elegida: 'Choisie', elegir: 'Choisir',
      unoNoDisp: '1 produit n’est pas disponible pour {x}.', variosNoDisp: '{n} produits ne sont pas disponibles pour {x}.',
      quitar: 'Retirer', pasarA: 'Passer à {x}',
      sinElegir: 'Livraison ou retrait ?', elegirBtn: 'Choisir'
    };
    return { pt: pt, en: en, fr: fr }[lang] || es;
  };
var SVG = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true">';
window.TalhoEntregaIconos = { envio: SVG + '<path d="M2 6h11v10H2z"/><path d="M13 10h4l3 3v3h-7"/><circle cx="6" cy="17.5" r="1.8"/><circle cx="17" cy="17.5" r="1.8"/></svg>',
  tienda: SVG + '<path d="M3 10l2-6h14l2 6"/><path d="M4 10v10h16V10"/><path d="M3 10h18"/><path d="M10 20v-5h4v5"/></svg>',
  x: SVG + '<path d="M6 6l12 12M18 6L6 18"/></svg>'
};
})();